import PropTypes from 'prop-types';
import React from 'react';
import { eventStatusTypes } from '../../Includes/Constants/events';
import Button from '../../Input/Button/Button';

import './InProgressBanner.scss';

const InProgressBanner = ({ eventStatus, joinUrl }) => {
    const inProgressText =
        eventStatus === eventStatusTypes.STARTING_SOON
            ? 'Get ready! The event is starting soon'
            : 'Event is in progress. Join now';

    return (
        <div className="component-Events-InProgressBanner">
            <div className="inProgress-text">{inProgressText}</div>
            <div className="inProgress-banner-button-div">
                <a href={joinUrl}>
                    <Button type="solid" value="Go to the event" />
                </a>
            </div>
        </div>
    );
};

export default InProgressBanner;

InProgressBanner.propTypes = {
    joinUrl: PropTypes.string,
    eventStatus: PropTypes.string,
};

InProgressBanner.defaultProps = {
    joinUrl: undefined,
    eventStatus: undefined,
};
